import { useQuery } from '@tanstack/react-query'

import { api } from '../../../shared/api'

export function useMediaStats() {
  return useQuery({
    queryKey: ['media', 'stats'],
    queryFn: () =>
      api<{
        byStatus: Record<string, number>
        byType: Record<string, number>
        totalBytes: number
      }>('/media/stats'),
  })
}
